<template>
	<section class="renzh">
		<div class="title">
			<img src="../../assets/imgs/qiyeziliao/ziliao3.png" alt="">
			<span>企业资料认证审核中，请耐心等待...</span>
		</div>
		<img src="../../assets/imgs/qiyeziliao/ziliao2.png" alt="">
	</section>
</template>

<script>
export default {
	name:"qiyeRenzh",
	data(){
		return{

		}
	}
}
</script>
<style lang="less" scoped>
	.renzh{
		width:980px;
		min-height: 700px;
		text-align: center;
		background:#fff;
		margin-left:20px;
		box-sizing:border-box;
		padding:120px;
		.title{
			height: 100px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 59px;
				height: 65px;
			}
			span{
				margin-left: 20px;
				font-size: 20px;
				font-weight: 600;
			}
		}
		img{
			width: 282px;
			height: 291px;
		}
	}
</style>
